import api from "../../client";
import { UpdateFieldPayload, UpdateFieldResponseData } from "../../types/enum";

export const updateFieldRequest = async (
  id: string | undefined,
  payload: UpdateFieldPayload,
) => {
  const { data } = await api.put<UpdateFieldResponseData>(
    `/field/${id}`,
    payload,
  );

  return data;
};
